import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Fiberglass from '@/pages/Fiberglass';
import Cellulose from '@/pages/Cellulose';
import Denim from '@/pages/Denim';
import Wool from '@/pages/Wool';
import Rigid from '@/pages/Rigid';
import Machines from '@/pages/Machines';
import Accessories from '@/pages/Accessories';
import Contact from '@/pages/Contact';
import HVAC from '@/pages/HVAC'
import Spray from '@/pages/Spray'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/about-us',
      name: 'About',
      component: About
    },
    {
      path: '/fiberglass',
      name: 'Certainteed-Fiberglass',
      component: Fiberglass,
    },
    {
      path: '/cellulose',
      name: 'Cellulose',
      component: Cellulose,
    },
    {
      path: '/denim',
      name: 'Denim',
      component: Denim,
    },
    {
      path: '/wool',
      name: 'Mineral Wool',
      component: Wool,
    },
    {
      path: '/rigid-board',
      name: 'Rigid-Board',
      component: Rigid,
    },
    {
      path: '/spray-foam',
      name: 'Spray Foam',
      component: Spray,
    },
    {
      path: '/hvac-supplies',
      name: 'HVAC Supplies',
      component: HVAC,
    },
    {
      path: '/machines',
      name: 'Machines',
      component: Machines,
    },
    {
      path: '/accessories',
      name: 'Accessories',
      component: Accessories,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '*',
      name: 'CatchAll',
      component: Home
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return{ x: 0, y: 0 }
  }
});

export default router;